import React from 'react';
import CountTo from './CountTo';
import langs from "./langs/phpIndex";


import "./css/DashIcon.css";
class DashIcon extends React.Component {
	render(){
    let lang = langs[this.props.lang];
		return (<div className="col-md-2 col-sm-4 col-xs-6 tile_stats_count dashicon">
                {this.props.children}
                {
                  !!this.props.showData ? 
                    <i className="showDataBtn fa fa-external-link" aria-hidden="true" onClick={this.props.showData} data-toggle="modal" data-target=".bs-example-modal-lg"></i>
                  : null
                }
                <span className="count_top">
                  <i className={"fa fa-" + this.props.icon}></i> {this.props.text}
                </span>
              	<CountTo to={isNaN(this.props.number) ? 0 : this.props.number} speed={1200} digits={this.props.digits} tagName="div" className="count" />
                {
                  this.props.percent && isFinite(this.props.percent) ?
                    <span className="count_bottom">
                      <i className={this.props.positive ? "green" : "red"}>
                        <i className={this.props.positive ? "fa fa-sort-asc" : "fa fa-sort-desc"}></i>
                        <CountTo to={this.props.percent} speed={1200} tagName="i" className="" />%
                      </i> {this.props.lang ? lang['SINCE_WEEK'] : 'siden sidste uge'}
                    </span>
                  : ""
                }
            </div>);
	}
}

export default DashIcon;


// WEBPACK FOOTER //
// ./src/components/DashIcon.js